module.exports = __webpack_public_path__ + "media/images/load_alternatives-c33d8e7f7688e09414b9007d95c007af.png";